const trustItems = [
  { icon: 'ri-award-line', text: '19 Jahre Dental-Erfahrung' },
  { icon: 'ri-shield-check-line', text: 'Schmerzfreie Aufhellung ohne Peroxid' },
  { icon: 'ri-user-heart-line', text: 'Über 100+ strahlende Gäste' },
  { icon: 'ri-women-line', text: 'Inhabergeführt von einer Frau' },
];

export default function TrustBar() {
  return (
    <section className="bg-blush border-b border-rose/20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-center divide-y sm:divide-y-0 sm:divide-x divide-rose/20">
          {trustItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-3 px-8 py-6 sm:py-8 flex-1 justify-center"
            >
              <span className="w-9 h-9 flex items-center justify-center bg-rose/15 rounded-full">
                <i className={`${item.icon} text-rose text-lg`} />
              </span>
              <span className="font-sans text-sm md:text-base font-medium text-charcoal whitespace-nowrap">
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
